import React from 'react';
import "./style.scss";
import BanIcon from "@material-ui/icons/Block";
import { withStyles } from '@material-ui/core';
import Fab from '@material-ui/core/Fab';
import SwapMove from '../icons/SwapMove';
import InsertBefore from '../icons/InsertBefore';
import { getCustomerName } from '../../modules/IBPlanning/Common/MergeStops/utills';

const styles =theme=>({
    arrowHTMLCode:{
        display: 'inline-block',
        verticalAlign: 'top',
        padding: '0px 10px',
        color: theme.iconColor,
        paddingTop: '3px',
    },
    fabStyles:{
        minHeight: "0px",
        height: "22px",
        width: "22px",
        fontSize: "10px",
        fontWeight:"bold",
        backgroundColor:"transparent",
        boxShadow:"none"
    },
    stopNameLabel:{
        verticalAlign: 'top',
        width: '60px',
        display: 'inline-block',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
    },
    messageStyle:{
        display: "inline-table",
        verticalAlign: "middle",
    },
    banIcon:{
        verticalAlign:"middle",
        color: 'darkRed',
    },
    iconContainer:{
        display:'inline-block',
        fontSize: '10px'
    },
    leftFabContainer:{
        margin: '0px 10px 0px 0px',
        display: 'inline-block',
    },
    rightFabContainer:{
        margin: '0px 0px 0px 10px',
        display: 'inline-block',
    },
    containerPadding:{
        padding: '10px 5px 5px',
        width:"100%",
        textAlign:"center"
    },
    routeNameLabel:{
        textAlign: 'center',
        fontWeight:"bold"
    },
    messageContainer:{
        width:"100%"
    }

})
const StopMovePopUpInfo = (props) => {
    const {classes, nearestStop, selectedStop} = props;
    const {banIcon, messageStyle, iconContainer, leftFabContainer, containerPadding, fabStyles, stopNameLabel, arrowHTMLCode, rightFabContainer, routeNameLabel  } = classes;
    return (
        nearestStop && nearestStop.routeStopId === selectedStop.routeStopId ? 
        <div className={`${classes.messageContainer} popupInfo popupBGColor`}>
            <div><BanIcon className={banIcon} /> <div className={messageStyle}>Destination stop is same as Source </div></div>
        </div>
        : (nearestStop.stopType=="AP"?<div  className={`${classes.messageContainer} popupInfo popupBGColor`}><BanIcon className={banIcon} /> <div className={messageStyle}>Cannot swap a stop with anchor point </div></div>
            :
            <div className={`${nearestStop.routeId !== selectedStop.routeId ? containerPadding:'popupInfo'} popupBGColor`}>
            <div align="left" className={iconContainer}>
                <div className={leftFabContainer}>
                    <Fab style={{border:`1px solid ${props.selectedStopColor}`, color:props.selectedStopColor}} className={`${fabStyles}`} size="small" disableRipple={true} disableFocusRipple={true}>
                        {selectedStop.stopSequence}
                    </Fab> 
                    {nearestStop.routeId !== selectedStop.routeId &&  <div style={{color:props.selectedStopColor}} className={routeNameLabel}>{selectedStop.routeName}</div>}
                </div>
                <div className={stopNameLabel}>{getCustomerName(selectedStop)}</div>
            </div>
            <div className={arrowHTMLCode}>
                {nearestStop.routeId !== selectedStop.routeId ? <InsertBefore />  : <SwapMove /> }
            </div>
            <div align="right" className={iconContainer}>
                <div className={stopNameLabel}>{getCustomerName(nearestStop)}</div>
                <div className={rightFabContainer}>
                    <Fab style={{border:`1px solid ${props.nearestStopColor}`, color:props.nearestStopColor}} className={`${fabStyles}`} size="small" disableRipple={true} disableFocusRipple={true}>
                        {nearestStop.stopSequence}
                    </Fab>  
                    {nearestStop.routeId !== selectedStop.routeId &&  <div style={{color:props.nearestStopColor}} className={routeNameLabel}>{nearestStop.routeName}</div>}
                </div>
            </div> 
        </div>)
    )
};

export default withStyles(styles)(StopMovePopUpInfo);
